/* PM calculator result grid. Fetches section pm-calc-grid via the Section Rendering API and injects site cards.
v4.6 personalised mix: every key lists ordered sources with quotas (primary tag, secondary tags, devta/graha tags, the user's own
rashi or moolank tail). Cards are picked per quota, topped up round-robin, deduped by handle and interleaved so the first cards
already come from different sources. Layout: headline -> grid -> details.
ctx (optional, from the calculator): {state:'active'|'dhaiya'|'clear', phase:'rising'|'peak'|'setting'|'kantaka'|'ashtama', rashi:'<slug>', moolank:'<1-9>'}.
Hand it over with PMCalcGrid.setCtx(calc, ctx), a 'pmcalc:ctx' event (detail {calc,ctx}), a data-pm-ctx or data-pmcg-ctx JSON attribute on the result panel, or window.PMCalcCtx[calc]. */
(function(){
if(window.PMCalcGrid) return;
var SECTION='pm-calc-grid', MAXMAIN=12, MINTOTAL=8, cache={}, store={}, SALT=14, ROT0=4, ROT=10;
function hsh(s){var h=5381;for(var i=0;i<s.length;i++)h=((h<<5)+h+s.charCodeAt(i))>>>0;return h;}
window.dataLayer=window.dataLayer||[];
var RASHI={mesh:['aries','Aries','mesh'],vrishabh:['taurus','Taurus','vrishabh'],mithun:['gemini','Gemini','mithun'],kark:['cancer','Cancer','kark'],singh:['leo','Leo','singh'],kanya:['virgo','Virgo','kanya'],tula:['libra','Libra','tula'],vrishchik:['scorpio','Scorpio','vrishchik'],dhanu:['sagittarius','Sagittarius','dhanu'],makar:['capricorn','Capricorn','makar'],kumbh:['aquarius','Aquarius','kumbh'],meen:['pisces','Pisces','meen']};
var RSLUG={};Object.keys(RASHI).forEach(function(k){RSLUG[RASHI[k][0]]=k;RSLUG[k]=k;});
RSLUG.karka='kark';RSLUG.simha='singh';RSLUG.vrishchika='vrishchik';RSLUG.vrischik='vrishchik';RSLUG.kumbha='kumbh';RSLUG.mina='meen';RSLUG.dhanus='dhanu';
var SIGNX={
mesh:{g:['mangal'],d:['hanuman'],s:['carnelian','red-jasper']},
vrishabh:{g:['shukra'],d:['maa-lakshmi'],s:['rose-quartz','green-aventurine']},
mithun:{g:['budh'],d:['ganesh-ji'],s:['green-aventurine']},
kark:{g:['chandra'],d:['lord-shiva'],s:['howlite','rose-quartz']},
singh:{g:['surya'],d:['lord-shiva'],s:['tiger-eye','citrine','copper']},
kanya:{g:['budh'],d:['lord-vishnu','tulsi'],s:['pyrite','green-aventurine']},
tula:{g:['shukra'],d:['maa-lakshmi'],s:['lapis-lazuli','rose-quartz'],sk:2},
vrishchik:{g:['mangal'],d:['maa-durga','hanuman'],s:['garnet','black-obsidian']},
dhanu:{g:['guru'],d:['lord-vishnu'],s:['citrine']},
makar:{g:['shani'],d:['hanuman'],s:['karungali','black-obsidian']},
kumbh:{g:['shani'],d:['hanuman'],s:['lapis-lazuli','pyrite'],sk:1},
meen:{g:['guru'],d:['lord-vishnu','tulsi'],s:['amethyst','citrine'],sk:1}
};
function signTags(k){var r=RASHI[k],t=[r[0],r[2]+'-rashi'];if(k==='kark')t.push('karka-rashi');return t;}
var MOOL={
'1':{g:'Sun / Surya',feat:'numero-bracelet-ruling-number-1-sun',src:[[['surya','sun'],3],[['tiger-eye','citrine'],4],[['copper'],2]]},
'2':{g:'Moon / Chandra',feat:'numero-bracelet-ruling-number-2-moon',src:[[['chandra','moon'],4],[['lord-shiva'],3],[['rose-quartz','howlite'],3]]},
'3':{g:'Jupiter / Guru',feat:'numero-bracelet-ruling-number-3-jupiter',src:[[['guru','jupiter','brihaspati'],4],[['citrine'],3],[['lord-vishnu','tulsi'],3]]},
'4':{g:'Rahu',feat:'numero-bracelet-ruling-number-4-rahu',src:[[['rahu'],4],[['black-obsidian'],3],[['karungali-bracelet'],2],[['maa-durga','durga'],2],[['navgraha'],1]],fill:[['maa-durga'],['karungali'],['black-obsidian'],['kirtimukh']]},
'5':{g:'Mercury / Budh',feat:'numero-bracelet-ruling-number-5-mercury',src:[[['budh','mercury'],4],[['green-aventurine'],3],[['ganesh-ji'],3]]},
'6':{g:'Venus / Shukra',feat:'numero-bracelet-ruling-number-6-venus',src:[[['shukra','venus'],4],[['rose-quartz','love'],3],[['maa-lakshmi'],3]]},
'7':{g:'Ketu',feat:'numero-bracelet-ruling-number-7-ketu',src:[[['ketu'],3],[['ganesh-ji'],3],[['karungali'],3],[['navgraha','9-mukhi-rudraksha'],1]],fill:[['ganesh-ji'],['karungali'],['kirtimukh'],['black-obsidian']]},
'8':{g:'Saturn / Shani',feat:'numero-bracelet-ruling-number-8-saturn',src:[[['shani','saturn'],3],[['lapis-lazuli'],3],[['black-obsidian'],2],[['karungali-bracelet'],2],[['hanuman'],2]]},
'9':{g:'Mars / Mangal',feat:'numero-bracelet-ruling-number-9-mars',src:[[['mangal','mars'],4],[['hanuman'],3],[['red-jasper','carnelian','garnet'],3]]}
};
var DEVTA={
surya:{n:'Surya',src:[[['surya'],4,{sk:3}],[['lord-shiva'],3],[['copper'],2,{sk:2}],[['kirtimukh'],1]]},
shiva:{n:'Shiva',src:[[['lord-shiva'],5],[['shiv-mala'],3],[['trishul'],2],[['rudraksha-bracelet'],2]]},
vishnu:{n:'Vishnu',src:[[['lord-vishnu'],5],[['tulsi','tulsi-mala'],3],[['lord-krishna'],2],[['vaishnav'],2]]},
durga:{n:'Durga',src:[[['maa-durga','durga','goddess-durga'],4],[['navratri'],3],[['trishul'],2],[['black-obsidian'],1],[['karungali'],2]]},
ganesha:{n:'Ganesha',src:[[['ganesha','ganesh-ji'],5],[['lakshmi-ganesh'],3],[['green-aventurine'],2],[['dhan-yog'],2]]},
lakshmi:{n:'Lakshmi',src:[[['maa-lakshmi'],4],[['mahalakshmi','lakshmi'],3],[['rose-quartz'],2],[['dhan-yog'],2],[['vastu'],1]]},
hanuman:{n:'Hanuman',src:[[['hanuman'],5],[['hanuman-ji','bajrang-bali','lord-hanuman'],3],[['karungali-bracelet'],2],[['mangal','shani'],2]]}
};
var SHANI={
rising:{sub:'Protection pieces to begin the Shani years with: karungali, black stone and copper.',src:[[['karungali-bracelet'],3],[['black-obsidian'],3],[['lapis-lazuli'],2],[['copper-bracelet'],2],[['protection'],1],[['shani'],1]]},
peak:{sub:'Shani, Hanuman and karungali pieces for the central years of Sade Sati.',src:[[['shani'],3],[['hanuman'],2],[['karungali'],3],[['7-mukhi-rudraksha'],2],[['pyrite'],1]]},
setting:{sub:'Steady Hanuman, Shani and Shiva pieces as the years ease.',src:[[['lord-shiva'],3],[['hanuman-chalisa'],2],[['tulsi-mala'],2],[['shani'],2],[['hanuman'],1]]},
kantaka:{sub:'Copper, black stone and Hanuman pieces for a Shani dhaiya.',src:[[['hanuman'],4],[['copper'],3],[['pyrite'],2],[['shani'],2],[['black-obsidian'],1]]},
ashtama:{sub:'Hanuman, karungali and Shani pieces for the ashtama years.',src:[[['karungali'],3],[['hanuman'],3],[['shani'],2],[['rudraksha-bracelet'],2],[['black-obsidian'],1]]}
};
var GENERIC_FILL=[['numerology-bracelet'],['kirtimukh']];
function tp(t){return '/collections/all/'+t;}
function S(tags,q,o){var s={t:tags,q:q};if(o)for(var k in o)s[k]=o[k];return s;}
function nrm(v){v=(v==null?'':String(v)).trim().toLowerCase();return v;}
function rk(v){v=nrm(v);return RSLUG[v]||null;}
function mk9(v){var n=String(parseInt(v,10));return MOOL[n]?n:null;}
function ctxClean(calc,x){
x=x||{};var o={};
var r=rk(x.rashi); if(r) o.rashi=r;
var m=mk9(x.moolank); if(m) o.moolank=m;
var st=nrm(x.state); if(st==='sadesati'||st==='sade-sati') st='active';
if(st==='active'||st==='dhaiya'||st==='clear') o.state=st;
var ph=nrm(x.phase); if(SHANI[ph]) o.phase=ph;
return o;
}
function tails(calc,ctx){
var t=[];
if(ctx.rashi&&calc!=='rashi'&&calc!=='shani'){
t.push(S(signTags(ctx.rashi),calc==='moolank'?4:(calc==='devta'?4:3),{ex:1,pr:1,lab:'rashi'}));
if(calc==='devta'){t.push(S(SIGNX[ctx.rashi].g,2,{pr:1,lab:'graha'}));t.push(S(SIGNX[ctx.rashi].s,1,{pr:1,lab:'stone'}));}
}
if(ctx.moolank&&calc!=='moolank'){var ms=MOOL[ctx.moolank].src;t.push(S(ms[0][0],calc==='devta'?3:2,{pr:1,lab:'moolank'}));if(calc==='devta') t.push(S(ms[2][0],2,{pr:1,lab:'moolank2'}));}
return t;
}
function fromPairs(a){return a.map(function(p){return S(p[0],p[1],p[2]);});}
function cfg(calc,key,ctx){
ctx=ctx||{};
var c=cfg0(calc,key,ctx);
if(!c) return c;
if(calc!=='moolank'&&ctx.moolank) c.rn=ctx.moolank;
c.src.forEach(function(s,i){
if(s.ex||s.nr) return;
s.sk=(s.sk||0)+hsh(calc+'|'+key+'|'+ctxSig(calc,ctx)+'|'+i+'|'+SALT)%(i===0?ROT0:ROT);
});
return c;
}
function cfg0(calc,key,ctx){
if(calc==='moolank'){
var m=MOOL[key]; if(!m) return null;
return {title:'More for Moolank '+key,sub:'Pieces tradition pairs with '+m.g+', the graha of your number.',src:fromPairs(m.src).concat(tails(calc,ctx)),fill:(m.fill||[]).concat(GENERIC_FILL),feat:m.feat,all:tp(m.src[0][0][0]),featLabel:'For your number',zc:1,hardz:1};
}
if(calc==='rashi'){
var r=RASHI[key]; if(!r) return null; var x=SIGNX[key];
var src=[S(signTags(key),6,{ex:1,lead:2}),S(x.g,2),S(x.d,2,x.sk?{sk:x.sk}:null),S(x.s,2)].concat(tails(calc,ctx));
return {title:'Made for '+r[1],sub:r[2].charAt(0).toUpperCase()+r[2].slice(1)+' rashi pieces, then the graha, devta and stones that go with the sign.',src:src,fill:[x.g,x.d,x.s],all:tp(r[0]),wc:3,zc:1};
}
if(calc==='devta'){
var d=DEVTA[key]; if(!d) return null;
return {title:'Picked for '+d.n,sub:'Pieces tradition keeps with '+d.n+'.',src:fromPairs(d.src).concat(tails(calc,ctx)),fill:GENERIC_FILL,all:tp(d.src[0][0][0]),wc:2,zc:1};
}
if(calc==='shani'){
var rs=ctx.rashi, sg=rs?RASHI[rs][1]:'';
if(key==='clear'){
var ty={ty:'Bracelets'}, cs;
if(rs){
var xx=SIGNX[rs];
cs=[S(signTags(rs),5,{ex:1,lead:3,ty:'Bracelets'}),S(xx.g,2,ty),S(['dhan-yog'],2,ty),S(xx.s,3,ty)];
cs.push({p:'/collections/zodiac-sign-bracelet',q:1,ty:'Bracelets'});
return {title:'Bracelets to wear',sub:'Your '+sg+' bracelets first, then bracelets that go with your sign.',src:cs,fill:[],fillp:['/collections/zodiac-sign-bracelet','/collections/pm-zodiac'],all:'/collections/zodiac-sign-bracelet',zc:8,wc:3};
}
cs=[{p:'/collections/zodiac-sign-bracelet',q:8,ty:'Bracelets'},S(['dhan-yog'],2,ty),S(['copper-bracelet'],2,ty)];
return {title:'Bracelets to wear',sub:'Zodiac and everyday bracelets, most loved first.',src:cs,fill:[],fillp:['/collections/pm-zodiac'],all:'/collections/zodiac-sign-bracelet',wc:3};
}
var ph=SHANI[key]||SHANI.peak, ss=fromPairs(ph.src), sub=ph.sub;
if(rs){ss.unshift(S(signTags(rs),4,{ex:1,lead:2,pr:1}));ss.push(S(SIGNX[rs].g,1,{pr:1}),S(SIGNX[rs].d,1,{pr:1}),S(SIGNX[rs].s,2,{pr:1}));sub+=' '+sg+' pieces come first.';}
return {title:'Picked for Shani',sub:sub,src:ss,fill:[['karungali']],all:tp('shani'),wc:2,zc:1};
}
return null;
}
function keepParams(root){
if(!location.search) return;
var sp;try{sp=new URLSearchParams(location.search);}catch(e){return;}
['moolank','rashi','devta','shani','section_id','sort_by'].forEach(function(k){sp.delete(k);});
if(!Array.from(sp.keys()).length) return;
[].forEach.call(root.querySelectorAll('a[href]'),function(a){
var h=a.getAttribute('href'); if(!h||h.charAt(0)!=='/'||h.indexOf('//')===0) return;
try{var u=new URL(h,location.origin);sp.forEach(function(v,k){if(!u.searchParams.has(k))u.searchParams.set(k,v);});a.setAttribute('href',u.pathname+u.search+u.hash);}catch(e){}
});
}
var ZOD=/\b(aries|taurus|gemini|cancer|leo|virgo|libra|scorpio|sagittarius|capricorn|aquarius|pisces)\b|राशि/i;
function meta(li){
var t=li.getAttribute('data-title')||'', tg=li.getAttribute('data-tags')||'', rn=/ruling number (\d)/i.exec(t);
return {h:li.getAttribute('data-handle'),t:t,ty:li.getAttribute('data-type')||'',z:ZOD.test(t)||/(^|,)(zodiac|rashi bracelet|zodiac bracelet)(,|$)/.test(tg),w:/\bwomen\b/i.test(t),rn:rn?rn[1]:'',html:li.outerHTML};
}
function fetchItems(path){
if(cache[path]) return cache[path];
var url=path+(path.indexOf('?')>-1?'&':'?')+'section_id='+SECTION+(path.indexOf('/products/')===0?'':'&sort_by=best-selling');
cache[path]=fetch(url,{credentials:'same-origin'}).then(function(r){if(!r.ok) throw new Error(r.status);return r.text();}).then(function(t){
var doc=new DOMParser().parseFromString(t,'text/html');
var ul=doc.querySelector('ul[data-pmcg-list]');
if(path.indexOf('/collections/all/')===0&&(!ul||ul.getAttribute('data-ct')==='0')) return [];
return [].map.call(doc.querySelectorAll('li.pmcg__item'),meta);
}).catch(function(){delete cache[path];return [];});
return cache[path];
}
function srcPaths(s){return s.p?[s.p]:s.t.map(tp);}
function srcList(s){
return Promise.all(srcPaths(s).map(fetchItems)).then(function(ls){
var out=[],n=0,i;ls.forEach(function(l){n=Math.max(n,l.length);});
for(i=0;i<n;i++) ls.forEach(function(l){if(i<l.length) out.push(l[i]);});
if(s.ty) out=out.filter(function(it){return it.ty===s.ty;});
if(s.sk) out=out.slice(s.sk);
return out;
});
}
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function skeleton(){var s='';for(var i=0;i<8;i++)s+='<i></i>';return '<div class="pmcg__sk" aria-hidden="true">'+s+'</div>';}
function list(items,feat,label){
return '<ul class="pmcg__grid product-grid lumin-grid">'+items.map(function(it,i){
var h=it.html;
if(feat&&i===0){h=h.replace('class="pmcg__item"','class="pmcg__item pmcg__item--feat"').replace(/^(<li[^>]*>)/,'$1<span class="pmcg__tag">'+esc(label||'')+'</span>');}
return h;
}).join('')+'</ul>';
}
function fit(src,room){
var q=src.map(function(s){return s.q;}),sum=function(){return q.reduce(function(a,b){return a+b;},0);};
var guard=60;
while(sum()>room&&guard--){
var bi=-1;for(var i=1;i<q.length;i++){ if(!src[i].pr&&q[i]>1&&(bi<0||q[i]>=q[bi])) bi=i; }
if(bi<0){ for(i=1;i<q.length;i++){ if(!src[i].pr&&q[i]>0&&(bi<0||q[i]>=q[bi])) bi=i; } }
if(bi<0){ for(i=1;i<q.length;i++){ if(q[i]>1&&(bi<0||q[i]>=q[bi])) bi=i; } }
if(bi<0){ for(var j=q.length-1;j>=1;j--){ if(q[j]>0){bi=j;break;} } if(bi<0) break; }
q[bi]--;
}
return q;
}
function compose(c,lists,hero){
var seen={},st={z:0,w:0,rn:0},total=0,room=MAXMAIN-(hero?1:0),ptr=c.src.map(function(){return 0;}),sel=c.src.map(function(){return [];});
if(hero) seen[hero.h]=1;
var quota=fit(c.src,room);
function ok(it,s,relax){
if(seen[it.h]) return false;
if(it.rn&&st.rn) return false;
if(it.rn&&!(c.rn&&String(c.rn)===it.rn)) return false;
if(!s.ex&&it.z&&c.zc!=null&&st.z>=c.zc&&!relax) return false;
if(it.w&&st.w>=(c.wc==null?3:c.wc)) return false;
return true;
}
function put(i,it){seen[it.h]=1;if(it.z&&!c.src[i].ex)st.z++;if(it.w)st.w++;if(it.rn)st.rn++;sel[i].push(Object.assign({},it,{si:i}));total++;}
function next(i,relax){var l=lists[i];while(ptr[i]<l.length){var it=l[ptr[i]++];if(ok(it,c.src[i],relax)) return it;}return null;}
var i,n,it,prog;
for(i=0;i<c.src.length;i++){for(n=0;n<quota[i]&&total<room;n++){it=next(i);if(!it)break;put(i,it);}}
do{prog=false;for(i=c.src.length-1;i>=0&&total<room;i--){ if(sel[i].length>=quota[i]+2) continue; it=next(i);if(it){put(i,it);prog=true;}}}while(prog&&total<room);
do{prog=false;for(i=0;i<c.src.length&&total<room;i++){it=next(i);if(it){put(i,it);prog=true;}}}while(prog&&total<room);
if(total<room&&!c.hardz){ /* last resort: lift the zodiac cap rather than show a short grid */
ptr=ptr.map(function(){return 0;});
do{prog=false;for(i=0;i<c.src.length&&total<room;i++){it=next(i,true);if(it){put(i,it);prog=true;}}}while(prog&&total<room);
}
var out=[],pos=sel.map(function(){return 0;});
if(hero) out.push(hero);
c.src.forEach(function(s,k){var L=Math.min(s.lead||0,sel[k].length);for(var a=0;a<L;a++){out.push(sel[k][pos[k]++]);}});
do{prog=false;for(i=0;i<sel.length;i++){if(pos[i]<sel[i].length){out.push(sel[i][pos[i]++]);prog=true;}}}while(prog);
return {main:out,seen:seen,st:st};
}
function block(calc,key,ctx){
var c=cfg(calc,key,ctx); if(!c) return Promise.resolve(null);
var jobs=[c.feat?fetchItems('/products/'+c.feat):Promise.resolve([])].concat(c.src.map(srcList));
return Promise.all(jobs).then(function(r){
var hero=r[0][0]||null, lists=r.slice(1);
var res=compose(c,lists,hero), main=res.main, hasFeat=!!hero;
var extra=[],title=c.title,sub=c.sub;
var need=MINTOTAL-main.length, next=Promise.resolve();
if(main.length===0){
title='Popular right now';sub='Our most loved pieces.';
next=Promise.all(['/collections/pm-zodiac','/collections/zodiac-sign-bracelet'].map(fetchItems)).then(function(f){f.forEach(function(l){l.forEach(function(it){if(main.length<MAXMAIN&&!res.seen[it.h]){res.seen[it.h]=1;main.push(it);}});});});
} else if(need>0){
var fs=(c.fill||[]).map(function(t){return S(t,0);}).concat((c.fillp||[]).map(function(p){return {p:p,q:0};}));
next=Promise.all(fs.map(srcList)).then(function(f){var cap=Math.min(MAXMAIN-main.length,Math.max(need,4));f.forEach(function(l){for(var i=0;i<l.length&&extra.length<cap;i++){var it=l[i];if(!res.seen[it.h]&&!it.rn){res.seen[it.h]=1;extra.push(it);}}});});
}
return next.then(function(){
var el=document.createElement('div');el.className='pmcg__block'+((main.length>6)?' has-more':'');
var html='<h2 class="pmcg__title">'+esc(title)+'</h2><p class="pmcg__sub">'+esc(sub)+'</p>'+list(main,hasFeat,c.featLabel);
if(extra.length) html+='<h3 class="pmcg__title pmcg__title--alt">Also loved with this</h3>'+list(extra,false);
var allHref=c.all||'/collections/all';
html+='<div class="pmcg__actions"><button type="button" class="pmcg__more">Show more</button><a class="pmcg__all" href="'+esc(allHref)+'">View all</a></div>';
el.innerHTML=html;
el.setAttribute('data-count',String(main.length+extra.length));
el.__main=main;el.__extra=extra;
el.querySelector('.pmcg__more').addEventListener('click',function(){el.classList.add('is-open');});
keepParams(el);
return el;
});
});
}
function mounts(){return [].slice.call(document.querySelectorAll('[data-pmcg]'));}
function crossCtx(mount){
var o={};
mounts().forEach(function(m){
if(m===mount||m.hidden) return;
var k=m.getAttribute('data-calc-key'),c=m.getAttribute('data-calc-page'); if(!k) return;
if(c==='rashi'&&rk(k)) o.rashi=rk(k);
if(c==='moolank'&&mk9(k)) o.moolank=mk9(k);
});
return o;
}
function domCtx(mount,calc,root){
var o={};
var el=root&&(root.getAttribute&&root.getAttribute('data-pm-ctx')?root:root.querySelector&&root.querySelector('[data-pm-ctx]'));
if(el){try{o=JSON.parse(el.getAttribute('data-pm-ctx'))||{};}catch(e){}}
var pe=root&&root.getAttribute&&root.getAttribute('data-pmcg-ctx')?root:(root&&root.querySelector&&root.querySelector('[data-pmcg-ctx]'));
if(pe){try{var pc=JSON.parse(pe.getAttribute('data-pmcg-ctx'))||{};for(var pk in pc) if(o[pk]==null) o[pk]=pc[pk];}catch(e){}}
else if(window.PMCalcCtx&&window.PMCalcCtx[calc]){var wc=window.PMCalcCtx[calc];for(var wk in wc) if(o[wk]==null) o[wk]=wc[wk];}
if(calc==='shani'){
var p=document.querySelector('#vsc-ss-picks .vsc-pick[aria-pressed="true"],.vsc-chipgrid .vsc-pick[aria-pressed="true"]');
if(p){ if(!o.rashi&&p.getAttribute('data-r')) o.rashi=p.getAttribute('data-r'); if(!o.state&&p.getAttribute('data-state')) o.state=p.getAttribute('data-state'); if(!o.phase&&p.getAttribute('data-phase')) o.phase=p.getAttribute('data-phase'); }
}
return o;
}
function ctxFor(mount,calc,root){
var a=crossCtx(mount),b=domCtx(mount,calc,root),c=store[calc]||{},o={},k;
for(k in a)o[k]=a[k]; for(k in b)o[k]=b[k]; for(k in c)o[k]=c[k];
return ctxClean(calc,o);
}
function ctxSig(calc,ctx){
var f=calc==='moolank'?['rashi']:calc==='rashi'?['moolank']:calc==='devta'?['rashi','moolank']:['state','phase','rashi'];
return f.map(function(k){return ctx[k]||'';}).join('.');
}
function shaniKey(ctx){
if(ctx.phase) return ctx.phase;
return ctx.state==='dhaiya'?'kantaka':'peak';
}
var token=0;
function show(mount,calc,keys,root){
var ctx=ctxFor(mount,calc,root);
if(calc==='shani') keys=[(keys[0]==='clear'||ctx.state==='clear')?'clear':shaniKey(ctx)];
var sig=keys.join(',')+'|'+ctxSig(calc,ctx);
mount.__last={calc:calc,keys:keys,root:root};
if(mount.__sig===sig&&mount.querySelector('.pmcg__block')){mount.hidden=false;return;}
var my=++token; mount.__t=my;
var body=mount.querySelector('[data-pmcg-body]');
body.innerHTML=skeleton(); mount.hidden=false;
Promise.all(keys.map(function(k){return block(calc,k,ctx);})).then(function(els){
if(mount.__t!==my) return;
body.innerHTML='';
var n=0;els.forEach(function(e){if(e){body.appendChild(e);n+=+e.getAttribute('data-count');}});
mount.__sig=sig;
mount.setAttribute('data-calc-key',keys.join(','));
mount.setAttribute('data-calc-ctx',ctxSig(calc,ctx));
window.dataLayer.push({event:'calc_result_view',calc:calc,key:keys.join(','),cards:n,ctx:ctxSig(calc,ctx)||undefined});
mounts().forEach(function(m){ if(m!==mount&&m.__last&&!m.hidden&&m.getAttribute('data-calc-key')) setTimeout(function(){show(m,m.__last.calc,m.__last.keys,m.__last.root);},0); });
});
}
function peek(calc,key,ctx){
ctx=ctxClean(calc,ctx);
if(calc==='shani') key=key==='clear'?'clear':(SHANI[key]?key:shaniKey(ctx));
return block(calc,String(key),ctx).then(function(el){return el?{title:el.querySelector('.pmcg__title').textContent,main:el.__main.map(function(i){return i.h;}),extra:el.__extra.map(function(i){return i.h;}),items:el.__main.concat(el.__extra).map(function(i){return {h:i.h,t:i.t,ty:i.ty,si:i.si,rn:i.rn};})}:null;});
}
function setUrl(mount,k,v){
if(mount.getAttribute('data-url')==='false') return;
try{var u=new URL(location.href);u.searchParams.set(k,v);history.replaceState(null,'',u.toString());}catch(e){}
}
function watch(el,fn){
if(!el) return;
var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(fn,0);}).observe(el,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden'],characterData:true});
}
function param(k){try{return new URLSearchParams(location.search).get(k);}catch(e){return null;}}
var EYE={moolank:'About your number',rashi:'About your rashi',devta:'About your devta',shani:'Your Shani reading in detail'};
function mkEl(tag,cls){var e=document.createElement(tag);if(cls)e.className=cls;return e;}
function layout(mount,calc,anchor,wantDet,res){
var w=mount.closest('.shopify-section')||mount;
if(anchor&&anchor.parentNode&&w!==anchor&&!anchor.contains(w)) anchor.parentNode.insertBefore(w,anchor.nextSibling);
if(!wantDet) return null;
var det=mkEl('div','vs vs-bg-white vs-section pmcg-det'); det.hidden=true;
det.innerHTML='<div class="vsc"><p class="vs-eyebrow">'+EYE[calc]+'</p><div class="pmcg-det__in"></div></div>';
if(w.parentNode) w.parentNode.insertBefore(det,w.nextSibling);
var card=res&&res.closest('.vsc-card'), nt=card&&card.nextElementSibling;
if(nt&&nt.classList.contains('vsc-note')){det.__card=card;det.__note=nt;}
return det;
}
function split(res,det,calc){
if(res.querySelector('[data-pmcg-split]')) return;
var inn=det.querySelector('.pmcg-det__in'); inn.innerHTML='';
var kids=[].slice.call(res.children);
if(calc==='devta'){
var big=res.querySelector('.vsc-big'); if(!big) return;
var row=mkEl('div','vsc-big'); row.style.cssText='align-items:flex-start;gap:28px';
[].slice.call(big.children).forEach(function(col){
var dc=mkEl('div'); dc.style.cssText='flex:1 1 260px';
var h=col.querySelector('h3'), t=col.querySelector('table');
if(h){var lab=mkEl('p','vs-eyebrow'); lab.style.margin='0 0 8px'; lab.textContent=h.textContent; dc.appendChild(lab);}
if(t){var n=t; while(n){var nx=n.nextSibling; dc.appendChild(n); n=nx;}}
row.appendChild(dc);
});
inn.appendChild(row);
kids.forEach(function(k){ if(k!==big) inn.appendChild(k); });
} else {
var tb=null; kids.forEach(function(k){ if(!tb&&k.tagName==='TABLE') tb=k; });
if(!tb) return;
var on=false; kids.forEach(function(k){ if(k===tb) on=true; if(on) inn.appendChild(k); });
}
[].forEach.call(inn.querySelectorAll('.vs-product'),function(p){p.parentNode.removeChild(p);});
var mkr=mkEl('span'); mkr.hidden=true; mkr.setAttribute('data-pmcg-split','1'); res.appendChild(mkr);
}
function sync(res,det,calc,mount){
if(res.hidden){
if(det){
det.hidden=true; mount.hidden=true;
if(det.__note&&det.__note.parentNode===det.querySelector('.pmcg-det__in')) det.__card.parentNode.insertBefore(det.__note,det.__card.nextSibling);
}
return false;
}
if(det){
split(res,det,calc);
if(det.__note&&det.__note.parentNode!==det.querySelector('.pmcg-det__in')) det.querySelector('.pmcg-det__in').appendChild(det.__note);
det.hidden=false;
}
return true;
}
function initMount(mount){
var calc=mount.getAttribute('data-calc-page'), urlOn=mount.getAttribute('data-url')!=='false';
mount.addEventListener('click',function(e){
var a=e.target.closest&&e.target.closest('.pmcg__item'); if(!a) return;
window.dataLayer.push({event:'calc_card_click',calc:calc,key:mount.getAttribute('data-calc-key'),handle:a.getAttribute('data-handle')});
});
mount.__redo=function(){ if(mount.__last&&!mount.hidden) show(mount,mount.__last.calc,mount.__last.keys,mount.__last.root); };
if(calc==='moolank'){
var res=document.getElementById('vsc-mo-res');
var hero=document.querySelector('.vsc-mo-hero');
var det=layout(mount,calc,hero||(res&&res.closest('section')),!hero,res);
var go=function(n){n=String(parseInt(n,10));if(!MOOL[n])return;show(mount,calc,[n],res);if(urlOn)setUrl(mount,'moolank',n);};
watch(res,function(){if(!sync(res,det,calc,mount))return;var e=res.querySelector('.vsc-num');if(e)go(e.textContent);});
var hn=document.querySelector('[data-pm-mo-n]');
if(hn) watch(hn,function(){if(hn.textContent.trim())go(hn.textContent);});
var q=param('moolank'); if(urlOn&&q) go(q);
} else if(calc==='rashi'){
var rr=document.getElementById('vsc-ra-res');
var rdet=layout(mount,calc,rr&&rr.closest('section'),true,rr);
var gor=function(k){if(!RASHI[k])return;show(mount,calc,[k],rr);if(urlOn)setUrl(mount,'rashi',RASHI[k][0]);};
watch(rr,function(){
if(!sync(rr,rdet,calc,mount)) return;
var p=document.querySelector('#vsc-ra-picks .vsc-pick[aria-pressed="true"]'),k=p?p.getAttribute('data-r'):null;
var h=rr.querySelector('h2'); var hk=h?h.textContent.trim().split(' ')[0].toLowerCase():'';
if(RASHI[hk]) k=hk;
if(k) gor(k);
});
var rq=param('rashi'); rq=rq&&RSLUG[rq.toLowerCase()];
if(urlOn&&rq){ var btn=document.querySelector('#vsc-ra-picks .vsc-pick[data-r="'+rq+'"]'); if(btn) btn.click(); else gor(rq); }
} else if(calc==='devta'){
var dr=document.getElementById('vsc-dv-res');
var ddet=layout(mount,calc,dr&&dr.closest('section'),true,dr);
var god=function(ks){var u=[];ks.forEach(function(k){if(DEVTA[k]&&u.indexOf(k)<0)u.push(k);});if(!u.length)return;show(mount,calc,u,dr);if(urlOn)setUrl(mount,'devta',u[0]);};
watch(dr,function(){if(!sync(dr,ddet,calc,mount))return;god([].map.call(dr.querySelectorAll('h3'),function(h){return h.textContent.trim().toLowerCase();}));});
var dq=param('devta'); if(urlOn&&dq) god([dq.toLowerCase()]);
} else if(calc==='shani'){
var sr=document.getElementById('vsc-ss-res');
var sdet=layout(mount,calc,sr&&sr.closest('section'),true,sr);
watch(sr,function(){
if(!sync(sr,sdet,calc,mount)) return;
var clear=!!sr.querySelector('.vsc-badge--off');
show(mount,calc,[clear?'clear':'1'],sr);
if(urlOn) setUrl(mount,'shani',clear?'clear':'1');
});
}
}
function setCtx(calc,ctx){
store[calc]=Object.assign({},ctx||{});
mounts().forEach(function(m){ if(m.getAttribute('data-calc-page')===calc&&m.__redo) m.__redo(); });
}
document.addEventListener('pmcalc:ctx',function(e){ var d=e&&e.detail; if(d&&d.calc) setCtx(d.calc,d.ctx); });
window.PMCalcGrid={init:function(){mounts().forEach(initMount);},setCtx:setCtx,peek:peek,_compose:compose,_cfg:cfg,_salt:function(n,a,b){SALT=n;if(a!=null)ROT0=a;if(b!=null)ROT=b;}};
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',window.PMCalcGrid.init); else window.PMCalcGrid.init();
})();
